import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@growdash/design-system/atoms';
import { useEffect, useState } from 'react';
type Props = {
  categories: string[];
  onValueChange: any;
  isCompetitorComponent?: boolean;
};

const CategoryButton = ({
  category,
  isSelected,
  onToggle,
  truncated,
}: {
  category: string;
  isSelected: boolean;
  onToggle: any;
  truncated?: boolean;
}) => (
  <div
    onClick={onToggle}
    className={`px-3 py-2 text-nowrap border  rounded-lg animate-fade-in cursor-pointer font-semibold transition-all duration-200 text-xs ${
      isSelected
        ? '!text-primary bg-[#EEEEFB] dark:bg-secondary dark:border-primary border-[#EEEEFB]'
        : 'text-tertiary border-bg_secondary'
    }
    ${truncated ? 'truncate max-w-[100px]' : ''}
    `}
  >
    {category}
  </div>
);

export default function CategorySelector({
  categories,
  onValueChange,
  isCompetitorComponent,
}: Props) {
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [collapsed, setCollapsed] = useState<any>(true);
  useEffect(() => {
    onValueChange && onValueChange(selectedCategories);
  }, [selectedCategories]);

  const onToggleCategory = (category: string, selected: boolean) => {
    if (selected) {
      setSelectedCategories(selectedCategories.filter((c) => c !== category));
      return;
    }
    setSelectedCategories([...selectedCategories, category]);
  };

  return (
    <div
      className={`${
        isCompetitorComponent
          ? 'border-b mt-[1px] w-[calc(100%)]'
          : 'w-[calc(100%+2px)] -translate-x-[1px] border relative'
      } bg-quarternary  border-tertiary p-4 pb-2 -translate-y-[1px] rounded-xl`}
    >
      <Accordion
        onValueChange={(val) => {
          setCollapsed(!val);
        }}
        type="single"
        collapsible
      >
        <AccordionItem value="item-1" className="border-none pr-0">
          <div className="flex items-center justify-between pb-2 gap-4 pr-4 min-h-[2.625rem]">
            <div className="flex items-center gap-2">
              <div
                className={`flex gap-2 items-center ${
                  collapsed ? '' : 'flex-wrap'
                }`}
              >
                {categories.slice(0, 3).map((category) => {
                  const selected = selectedCategories.includes(category);
                  return (
                    <CategoryButton
                      truncated={collapsed}
                      category={category}
                      isSelected={selected}
                      onToggle={() => {
                        onToggleCategory(category, selected);
                      }}
                    />
                  );
                })}
              </div>
              <span
                hidden={!collapsed}
                className="text-tertiary font-semibold text-xs leading-none"
              >
                {categories.length > 3 && `+${categories.length - 3}`}
              </span>
            </div>
            <div className="absolute right-0 top-0 bottom-0 flex items-start pt-2">
              <div className="w-full shadow-[-4px_2px_6px_inherit]">
                <AccordionTrigger className="pr-4 bg-quarternary" />
              </div>
            </div>
          </div>
          <AccordionContent className="flex gap-2 flex-wrap pt-0">
            {categories.slice(3, categories.length).map((category) => {
              const selected = selectedCategories.includes(category);
              return (
                <CategoryButton
                  truncated={collapsed}
                  category={category}
                  isSelected={selected}
                  onToggle={() => {
                    onToggleCategory(category, selected);
                  }}
                />
              );
            })}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
}
